// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AK4l","col":"styles_col__St3pK"};